import React, { useEffect, useState } from 'react';
import BsModal from '../Common/BsModal';
import { useGym } from '../../DataStore/Gym/GymContext';
import functions from '../../util/functions';
import ajaxGym from '../../util/remote/ajaxGym';
import Notification from '../Common/Notification';
import ActivityLoader from '../Common/ActivityLoader';

const RegisterNewCustomerModal = ({ show, onClose, onComplete}) => {
  const {customerPhoneNumber, getMembershipTypes, membershipTypeList, storeCustomerInfo, getRecentMembers} = useGym();
  const [formData, setFormData] = useState({
    full_name: '',
    phone_number: '',
    membership_type: {},
  });
 const [notify, setNotify] = useState(null);
 const [loading, setLoading] = useState(false);
  

  useEffect(() => {
    getMembershipTypes();
    }, []);

  useEffect(()=>{
    setFormData({ ...formData, phone_number: customerPhoneNumber });
  }, [customerPhoneNumber])


  useEffect(()=>{
          if(notify){
              setTimeout(() => {
                  setNotify(null);
              }, 5000);
          }
      }, [notify]);
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async() => {
    if(loading){return;}
    if(!formData.membership_type.id){
        setNotify(<Notification type='danger' message="Please select a membership type." />);
        return;
    }

    setLoading(true);
    setNotify(null);
    const server_response = await ajaxGym.registerCustomer({
        full_name: formData.full_name,
        phone_number: formData.phone_number,
        membership_type_id: formData.membership_type.id,
    });
    setLoading(false);
    if (server_response.status === "OK") {
        setFormData({
            full_name: '',
            phone_number: '',
            membership_type: {},
        });

        //refresh recent members
        getRecentMembers();
        setNotify(<Notification type='success' message={server_response.message} />);
        setTimeout(() => {
            storeCustomerInfo(server_response.details);
            onComplete(server_response.details);
            onClose();
        }, 2000);
    } else {
        setNotify(<Notification type='danger' message={server_response.message} />);
    }
  };


  return (
    <BsModal
      show={show}
      onClose={onClose}
      title="Register New Customer"
      footer={
        <>
         {!loading && <>
          <button className="btn btn-secondary" onClick={onClose}>Cancel</button>
          <button
            className="btn btn-success"
            onClick={handleSubmit}
            disabled={!formData.full_name}
          >
            <i className="fa fa-user-plus mr-1"></i> Register
          </button>
            </>}
            {loading && <ActivityLoader />}
        </>
      }
    >
        {notify}
      <div className="form-group">
        <label className="font-weight-bold" htmlFor="full_name">
          <i className="fa fa-user text-primary mr-2"></i> Full Name:
        </label>
        <input
          type="text"
          className="form-control"
          id="full_name"
          name="full_name"
          value={formData.full_name}
          onChange={handleChange}
          placeholder="Enter full name"
          required
        />
      </div>

      <div className="form-group">
        <label className="font-weight-bold" htmlFor="phone_number">
          <i className="fa fa-phone text-primary mr-2"></i> Phone Number:
        </label>
        <input
          type="text"
          className="form-control"
          id="phone_number"
          name="phone_number"
          value={formData.phone_number}
          onChange={handleChange}
          placeholder="Enter phone number"
          required
        />
      </div>

      <div className="form-group">
        <label className="font-weight-bold" htmlFor="membership_type">
          <i className="fa fa-id-card text-primary mr-2"></i> Membership Type:
        </label>
        <select
            className="form-control"
            id="membership_type"
            name="membership_type"
            value={formData.membership_type?.id || ''}
            onChange={(e) => {
            const selectedId = e.target.value;
            const selectedType = membershipTypeList.find(type => type.id.toString() === selectedId);
            setFormData({ ...formData, membership_type: selectedType || {} });
            }}
        >
            <option value="">Select Membership Type</option>
            {Array.isArray(membershipTypeList) && membershipTypeList.map((type) => (
            <option key={type.id} value={type.id}>
                {type.type_name} ({functions.numberFormat(type.standard_amount)})
            </option>
            ))}
        </select>
      </div>
    </BsModal>
  );
};

export default RegisterNewCustomerModal;
